import React, { useContext, useEffect, useMemo, useState } from 'react';
import DaumPostcode from 'react-daum-postcode';
import styled from 'styled-components';
import CustomModal from '../../components/modal/CustomModal';
import { AuthContext } from '../../navigation/AuthProvider';
import { focusInput, getNumberToString } from '../../utils/util';
import UtilController from '../../controller/UtilController';
import { useToast } from '../../controller/ToastController';
import AsyncLocalStorage from '../../utils/AsyncLocalStorage';
import StoreController, {
  CurrentStoreContext,
  StoreDetailType,
  StoreType,
} from '../../controller/StoreController';
import { useOutletContext } from 'react-router-dom';
import { SelectType } from '../../components/DropdownSelect';

const StoreInfo = () => {
  const showToast = useToast();
  const { userInfo } = useContext(AuthContext);
  const [addressModal, setAddressModal] = useState<boolean>(false);

  const [storeName, setStoreName] = useState<string>('');
  const [storeNameEn, setStoreNameEn] = useState<string>('');
  const [sAddress, setAddress] = useState<string>('');
  const [bCode, setBcode] = useState<string>('');
  const [sExtraAddress, setExAddress] = useState<string>('');
  const [sPhoneNm, setPhoneNm] = useState<string>('');
  const [storeNotice, setStoreNotice] = useState<string>('');
  const [storeEvent, setStoreEvent] = useState<string>('');
  const [storeOrigin, setStoreOrigin] = useState<string>('');

  const [confirmPassword, setConfirmPassword] = useState<string>('');

  const [logoImage, setLogoImage] = useState<string | null>(null);
  const [logoMediaId, setLogoMediaId] = useState<number | null>(null);

  const [storeImages, setStoreImages] = useState<StoreDetailType[]>([
    {
      seq: 0,
      store_image: [],
      store_description: '',
    },
  ]);

  const [visibleLogoGuide, setVisibleLogoGuide] = useState<boolean>(false);
  const [visibleImageGuide, setVisibleImageGuide] = useState<boolean>(false);

  const { onChangeCurrentStore } = useContext(AuthContext);
  const { currentStore } = useOutletContext<CurrentStoreContext>();

  // 이미지 등록
  const uploadLogoImage = async (e: any) => {
    console.log('files', e.target.files);
    let origin = e.target.files[0];
    if (origin !== undefined) {
      if (origin.type !== undefined && origin.type !== null) {
        if (origin.type === 'image/png' || origin.type === 'image/jpeg') {
          const formData = new FormData();
          formData.append('file', origin);
          const oRes = await UtilController.storeLogoUploadImg(formData, userInfo.user_id);
          console.log('storeLogoUploadImg', oRes);
          if (oRes.data) {
            const oResponse = oRes.data;
            if (oResponse.ok && oResponse.data) {
              setLogoImage(oResponse.data.url_path);
              setLogoMediaId(oResponse.data.store_media_id);
            } else {
              showToast('파일 이름이 너무 길거나 형식에 맞지 않아요', 'error');
            }
          }
          return;
        }
      }
    }
  };

  const uploadStoreImage = async (e: any, index: number) => {
    if (storeImages[index].store_image.length < 3) {
      console.log('files', e.target.files);
      let origin = e.target.files[0];
      if (origin !== undefined) {
        if (origin.type !== undefined && origin.type !== null) {
          if (origin.type === 'image/png' || origin.type === 'image/jpeg') {
            const formData = new FormData();
            formData.append('file', origin);
            const oRes = await UtilController.storeImageUploadImg(formData, userInfo.user_id);
            console.log('storeImageUploadImg', oRes);
            if (oRes.data) {
              const oResponse = oRes.data;
              if (oResponse.ok && oResponse.data) {
                storeImages[index].store_image.push({
                  store_media_id: oResponse.data.store_media_id,
                  url_path: oResponse.data.url_path,
                });
                setStoreImages([...storeImages]);
              } else {
                showToast('파일 이름이 너무 길거나 형식에 맞지 않아요', 'error');
              }
            }
            return;
          }
        }
      }
    } else {
      showToast('더 이상 사진을 등록할 수 없어요', 'error');
    }
  };

  const addStoreInfo = () => {
    if (storeImages.length < 3) {
      setStoreImages([
        ...storeImages,
        { seq: storeImages.length, store_image: [], store_description: '' },
      ]);
    }
    // console.log('storeinfo', storeImages);
  };

  const deleteStoreInfo = (index: number) => {
    storeImages.splice(index, 1);
    setStoreImages([...storeImages]);
    console.log('storeinfo', storeImages);
  };

  const sortStoreInfo = () => {
    let storeImageTemp: StoreDetailType[] = [];
    storeImages.map((item: StoreDetailType, index: number) => {
      storeImageTemp.push({
        seq: index,
        store_image: item.store_image,
        store_description: item.store_description,
      });
    });
    return storeImageTemp;
  };

  // 다음주소검색
  const handleComplete = async (data: any) => {
    let fullAddress = data.address;
    let extraAddress = '';

    if (data.addressType === 'R') {
      if (data.bname !== '') {
        extraAddress += data.bname;
      }
      if (data.buildingName !== '') {
        extraAddress += extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName;
      }
      fullAddress += extraAddress !== '' ? ` (${extraAddress})` : '';
    }
    setAddress(fullAddress);
    setAddressModal(false);
    setBcode(data.bcode);
  };
  const handleAddressModalClose = () => {
    setAddressModal(false);
  };

  // onChange
  const onChange_storeName = (event: any) => {
    setStoreName(event.target.value);
  };
  const onChange_storeNameEn = (event: any) => {
    setStoreNameEn(event.target.value);
  };
  const onChange_sAddress = (event: any) => {
    setAddress(event.target.value);
  };
  const onChange_sExtraAddress = (event: any) => {
    setExAddress(event.target.value);
  };
  const onChange_phoneNumber = (event: any) => {
    setPhoneNm(getNumberToString(event.target.value));
  };
  const onChange_storeNotice = (event: any) => {
    setStoreNotice(event.target.value);
  };
  const onChange_storeEvent = (event: any) => {
    setStoreEvent(event.target.value);
  };
  const onChange_storeOrigin = (event: any) => {
    setStoreOrigin(event.target.value);
  };
  const onChange_confirmedPassword = (event: any) => {
    setConfirmPassword(getNumberToString(event.target.value));
  };

  const onChange_storeInfo = (index: number, event: any) => {
    let storeInfoTemp = storeImages;
    storeInfoTemp[index].store_description = event.target.value;
    setStoreImages([...storeInfoTemp]);
  };

  // const checkFocusItem = () => {
  //   if (storeName === null || storeName.length === 0) {
  //     focusInput(`storeName`);
  //   } else if (storeNameEn === null || storeNameEn.length === 0) {
  //     focusInput(`storeNameEn`);
  //   } else if (sAddress === null || sAddress.length === 0) {
  //     focusInput(`sAddress`);
  //   } else if (sPhoneNm === null || sPhoneNm.length === 0) {
  //     focusInput(`sPhoneNm`);
  //   } else if (logoImage === null || logoImage.length === 0) {
  //     focusInput(`logoImage`);
  //   } else if (storeOrigin === null || storeOrigin.length === 0) {
  //     focusInput(`storeOrigin`);
  //   } else if (confirmPassword === null || confirmPassword.length < 4) {
  //     focusInput(`confirmPassword`);
  //   }
  // };

  // 필수 확인
  const checkRequired = () => {
    if (
      storeName !== null &&
      storeName.length > 0 &&
      storeNameEn !== null &&
      storeNameEn.length > 0 &&
      sAddress !== null &&
      sAddress.length > 0 &&
      sExtraAddress !== null &&
      sExtraAddress.length > 0 &&
      sPhoneNm !== null &&
      sPhoneNm.length > 0 &&
      logoImage !== null &&
      storeOrigin !== null &&
      storeOrigin.length > 0 &&
      (checkHotelAccount() ? confirmPassword.length === 4 : confirmPassword)
    )
      return true;
    return false;
  };

  const deleteLogoImage = () => {
    setLogoImage(null);
    setLogoMediaId(null);
  };

  const deleteImage = (mainIndex: number, itemIndex: number) => {
    storeImages[mainIndex].store_image.splice(itemIndex, 1);
    setStoreImages([...storeImages]);
  };

  // API 호출
  const getStoreInfo = async () => {
    try {
      const oRes: any = await StoreController.getStore(currentStore.value);

      if (oRes && oRes.data) {
        const oResponse: any = oRes.data;
        console.log('getStore', oResponse);

        if (oResponse.data) {
          setStoreName(oResponse.data.store_name);
          setStoreNameEn(oResponse.data.store_name_en);
          setAddress(oResponse.data.address1);
          setExAddress(oResponse.data.address2);
          setPhoneNm(oResponse.data.phone_number);
          setLogoImage(oResponse.data.logo_url_path);
          setLogoMediaId(oResponse.data.logo_store_media_id);
          setStoreImages(oResponse.data.store_detail);
          setStoreNotice(oResponse.data.description_noti);
          setStoreEvent(oResponse.data.description_event);
          setStoreOrigin(oResponse.data.description_extra);
          setConfirmPassword(oResponse.data.confirm_password);
        }
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  const editStoreInfo = async () => {
    try {
      if (checkRequired()) {
        const oParams = {
          store_id: currentStore.value,
          store_name: storeName,
          store_name_en: storeNameEn,
          address1: sAddress,
          address2: sExtraAddress,
          phone_number: sPhoneNm,
          logo_store_media_id: logoMediaId,
          store_detail: sortStoreInfo(),
          description_noti: storeNotice,
          description_event: storeEvent,
          description_extra: storeOrigin,
          confirm_password: confirmPassword,
          bcode: bCode,
        };
        const oRes: any = await StoreController.editStore(oParams);

        if (oRes && oRes.data) {
          const oResponse: any = oRes.data;
          console.log('editStore', oResponse);
          if (oResponse.ok) {
            showToast('매장 정보를 변경했어요');
            // selectList와 defaultValue 값 재설정
            let storeList = await AsyncLocalStorage.getItem('ceo-userData');
            storeList.store_list[currentStore.key].store_name = storeName;
            AsyncLocalStorage.setItem('ceo-userData', JSON.stringify(storeList));
            AsyncLocalStorage.setItem(
              'ceo-currentStore',
              JSON.stringify({ ...currentStore, name: storeName, label: storeName }),
            );
            onChangeCurrentStore();
          }
        }
      } else {
        showToast('필수 정보를 입력해주세요', 'error');
        // checkFocusItem();
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  const checkHotelAccount = () => {
    return userInfo && userInfo.store_list.find((item: any) => item.store_type === 4)
      ? true
      : false;
  };

  useEffect(() => {
    getStoreInfo();
  }, [currentStore]);

  // useEffect(() => {
  //   getStoreInfo();
  // }, [currentStore]);

  const RenderLogoGuide = useMemo(() => {
    return (
      <div className={`guideBox logo ${visibleLogoGuide && 'active'}`}>
        <img
          src={`${process.env.PUBLIC_URL}/img/logoExample.png`}
          width={400}
          alt="미리보기 이미지"
          className="logoguideImage"
        />
      </div>
    );
  }, [visibleLogoGuide]);

  const RenderImageGuide = useMemo(() => {
    return (
      <div className={`guideBox store ${visibleImageGuide && 'active'}`}>
        <img
          src={`${process.env.PUBLIC_URL}/img/storeInfoExample.png`}
          className="storeguideImage"
          width={400}
          alt="미리보기 이미지"
        />
      </div>
    );
  }, [visibleImageGuide]);

  return (
    <>
      <Style>
        <div className="contentContainer top">
          <div className="inputText">
            <div className="title initial">
              <h4>매장명</h4>
              <h5>(필수)</h5>
            </div>
            <input
              id="storeName"
              // className={`${(storeName === null || storeName.length === 0) && 'error'}`}
              type="text"
              placeholder="매장명을 입력해주세요"
              value={storeName}
              onChange={onChange_storeName}
              autoFocus={true}
            />
          </div>
          <div className="inputText">
            <div className="title">
              <h4>영문매장명</h4>
              <h5>(필수)</h5>
            </div>
            <input
              id="storeNameEn"
              // className={`${(storeNameEn === null || storeNameEn.length === 0) && 'error'}`}
              type="text"
              placeholder="영문매장명을 입력해주세요"
              value={storeNameEn}
              onChange={onChange_storeNameEn}
              autoFocus={false}
            />
          </div>
          <div className="inputText">
            <div className="title">
              <h4>매장주소</h4>
              <h5>(필수)</h5>
            </div>
            <div className="address">
              <input
                id="sAddress"
                // className={`${(sAddress === null || sAddress.length === 0) && 'error'}`}
                type="text"
                value={sAddress}
                placeholder="도로명 주소를 입력해주세요"
                autoFocus={false}
                style={{
                  marginBottom: '8px',
                  // backgroundColor: 'rgb(229, 229, 229)',
                  // cursor: 'not-allowed',
                }}
              />
              <button
                className="searchBox"
                onClick={() => {
                  setAddressModal(true);
                }}>
                <img src={`${process.env.PUBLIC_URL}/svg/ic_search.svg`} alt="search" />
              </button>
            </div>
            <input
              type="text"
              placeholder="상세주소를 입력해주세요"
              value={sExtraAddress}
              onChange={onChange_sExtraAddress}
              autoFocus={false}
            />
          </div>
          <div className="inputText">
            <div className="title">
              <h4>매장 전화번호</h4>
              <h5>(필수)</h5>
            </div>
            <input
              id="sPhoneNm"
              // className={`${(sPhoneNm === null || sPhoneNm.length === 0) && 'error'}`}
              type="text"
              placeholder="- 를 제외하고 입력해주세요"
              value={sPhoneNm}
              onChange={onChange_phoneNumber}
              autoFocus={false}
            />
          </div>
          {/* <div className="inputText">
              <div className="title">
                <h4>매장 소개글</h4>
                <h5>(필수)</h5>
              </div>
              <textarea
                placeholder="우리 매장을 소개하는 내용을 작성해주세요"
                value={storeInfo}
                onChange={onChange_storeInfo}
              />
            </div> */}

          <div className="inputText">
            <div className="title guide">
              <h4>로고 이미지</h4>
              <h5>(필수)</h5>
              <div className="guideImageWrap">
                <img
                  onMouseEnter={() => setVisibleLogoGuide(true)}
                  onMouseLeave={() => setVisibleLogoGuide(false)}
                  src={`${process.env.PUBLIC_URL}/svg/ic_question.svg`}
                  alt="가이드아이콘"
                />
                {visibleLogoGuide && RenderLogoGuide}
              </div>
            </div>
            <div className="imageList logo">
              <input
                id="logoImage"
                // className={`${(logoImage === null || logoImage.length === 0) && 'error'}`}
                type="file"
                name="photo"
                accept="image/*"
                autoFocus={false}
                onChange={uploadLogoImage}
              />
              {logoImage === '' || logoImage === null ? (
                <label className="photoBox logo" htmlFor="logoImage">
                  <img src={`${process.env.PUBLIC_URL}/svg/ic_photo.svg`} alt="ic" />
                  <h5>이미지 추가</h5>
                </label>
              ) : (
                <div className="previewImageWrap logo">
                  <img className="previewImg" src={logoImage} alt="img" />
                </div>
              )}
              {logoImage !== '' && logoImage !== null && (
                <>
                  <label className="imageButton edit" htmlFor="logoImage">
                    수정
                  </label>
                  <button className="imageButton delete" onClick={deleteLogoImage}>
                    삭제
                  </button>
                </>
              )}
            </div>
          </div>
        </div>

        {checkHotelAccount() && (
          <div className="contentContainer">
            <h3 className="subtitle">직원확인 비밀번호</h3>
            <div className="inputText">
              <div className="title initial">
                <h4>비밀번호</h4>
                <h5>(필수)</h5>
              </div>
              <input
                id="confirmPassword"
                // className={`${(confirmPassword === null || confirmPassword.length < 4) && 'error'}`}
                type="text"
                placeholder="직원확인 비밀번호를 4자리로 입력해주세요"
                value={confirmPassword}
                onChange={onChange_confirmedPassword}
                autoFocus={false}
                maxLength={4}
              />

              <div className="warningSign">
                <img src={`${process.env.PUBLIC_URL}/svg/ic_warning.svg`} alt="ic" />
                <div>
                  <p>
                    비밀번호를 설정하지 않은 경우, 기본값은 매장 전화번호의 뒷자리 4자리로 자동
                    설정됩니다.
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="contentContainer bottom">
          <div className="infoBadge">
            <h4>우리매장 상세소개</h4>
          </div>
          <div className="inputText">
            <div className="title guide">
              <h4>매장 이미지 및 메뉴 사진</h4>
              <h5 className="greenFont">(최대 3장)</h5>
              <div className="guideImageWrap">
                <img
                  onMouseEnter={() => setVisibleImageGuide(true)}
                  onMouseLeave={() => setVisibleImageGuide(false)}
                  src={`${process.env.PUBLIC_URL}/svg/ic_question.svg`}
                  alt="가이드 아이콘"
                />
                {visibleImageGuide && RenderImageGuide}
              </div>
            </div>
            {storeImages.map((item: StoreDetailType, index: number) => {
              return (
                <div className="storeInfoWrap" key={index}>
                  <div className="imageWrap">
                    <div className="imageList">
                      <label className="photoBox" htmlFor={`storeImage${index}`}>
                        <img src={`${process.env.PUBLIC_URL}/svg/ic_photo.svg`} alt="ic" />
                        <h5>이미지 추가</h5>
                      </label>
                      <input
                        id={`storeImage${index}`}
                        type="file"
                        name="photo"
                        accept="image/*"
                        autoFocus={false}
                        onChange={(e) => uploadStoreImage(e, index)}
                        disabled={item.store_image.length >= 3}
                      />
                      {item.store_image.map((image: any, imageIndex: number) => {
                        return (
                          <div className="previewImageWrap" key={imageIndex}>
                            <div className="imageDeleteButton">
                              <img
                                src={`${process.env.PUBLIC_URL}/svg/ic_close_white.svg`}
                                onClick={() => deleteImage(index, imageIndex)}
                                alt="ic"
                              />
                            </div>
                            <img className="previewImg" src={image.url_path} alt="none_image" />
                          </div>
                        );
                      })}
                    </div>
                    {storeImages.length > 1 && (
                      <button className="imageButton delete" onClick={() => deleteStoreInfo(index)}>
                        삭제
                      </button>
                    )}
                  </div>
                  <textarea
                    placeholder="우리 매장, 메뉴 등을 소개하는 내용을 작성해주세요"
                    value={item.store_description}
                    onChange={(e) => onChange_storeInfo(index, e)}
                    autoFocus={false}
                  />
                </div>
              );
            })}
            {storeImages.length < 3 && (
              <button className="addButton" onClick={addStoreInfo}>
                <img src={`${process.env.PUBLIC_URL}/svg/ic_plus.svg`} alt="ic" />
                <h5>매장소개 추가하기</h5>
              </button>
            )}
          </div>
          <div className="inputText">
            <div className="title">
              <h4>공지사항</h4>
            </div>
            <textarea
              placeholder="가격변동, 긴급휴무일 등 고객에게 알리고 싶은 가게 상황을 적어주세요"
              value={storeNotice}
              onChange={onChange_storeNotice}
              autoFocus={false}
            />
          </div>
          <div className="inputText">
            <div className="title">
              <h4>이벤트</h4>
            </div>
            <textarea
              placeholder="이벤트 내용을 적어주세요"
              value={storeEvent}
              onChange={onChange_storeEvent}
              autoFocus={false}
            />
          </div>
          <div className="inputText">
            <div className="title">
              <h4>원산지 표기사항</h4>
              <h5>(필수)</h5>
            </div>
            <textarea
              id="storeOrigin"
              // className={`${(storeOrigin === null || storeOrigin.length === 0) && 'error'}`}
              placeholder="매장에서 사용하는 재료의 원산지를 자세하게 적어주세요"
              value={storeOrigin}
              onChange={onChange_storeOrigin}
              autoFocus={false}
            />
          </div>
          <button
            className={`submitButton ${!checkRequired() && 'inactive'}`}
            onClick={editStoreInfo}>
            매장정보 등록
          </button>
        </div>
      </Style>
      <CustomModal isVisible={addressModal} setVisible={setAddressModal}>
        <div style={{ display: 'flex' }}>
          <button
            onClick={handleAddressModalClose}
            style={{ marginLeft: 'auto', marginRight: '1%' }}>
            <img src={`${process.env.PUBLIC_URL}/svg/ic_close.svg`} alt="ic" />
          </button>
        </div>
        <DaumPostcode
          onComplete={handleComplete}
          onClose={handleAddressModalClose}
          autoClose
          style={{ height: window.innerWidth > 1200 ? '54vh' : '70vh' }}
        />
      </CustomModal>
    </>
  );
};

export default StoreInfo;

const Style = styled.div`
  .contentContainer.top {
    border-radius: 10px 10px 0 0;
  }
  .contentContainer {
    border-radius: 0;
  }
  .contentContainer.bottom {
    border-radius: 0 0 10px 10px;
  }

  .inputText {
    img {
      cursor: pointer;
    }

    .title {
      padding: 30px 0 6px 0;
      display: flex;
      align-items: center;
      gap: 4px;

      h5 {
        color: #40977f;
        font-weight: 500;
      }
      .greenFont {
        color: #40977f;
      }
      h4 {
        color: #555555;
      }
    }
    .title.initial {
      padding: 0 0 6px 0;
    }

    input,
    textarea {
      width: 100%;
      padding: 10px 12px;
      border: 1px solid #cecece;
      border-radius: 5px;
      color: #555555;
    }

    input::placeholder,
    textarea::placeholder {
      color: #a7a7a7;
    }

    textarea {
      min-height: 120px;
    }
  }

  /* guideImageWrap */
  .guideImageWrap {
    display: inline-flex;
    position: relative;
  }
  .guideBox {
    position: absolute;
    top: 0px;
    left: 20px;
    opacity: 0;
    z-index: 2;
  }
  .guideBox.active {
    animation: fadeIn 0.2s ease-in-out forwards;
  }

  .infoBadge {
    background: #ecf5f3;
    border-radius: 5px;
    display: flex;
    align-items: center;
    padding: 8px 20px;
    gap: 6px;
    h4 {
      color: #555555;
    }
  }

  /* 주소검색 */
  .address {
    position: relative;

    .searchBox {
      margin-bottom: 8px;
      position: absolute;
      top: 0;
      bottom: 0;
      padding: 10px 20px;
      border: none;
      background: #4dd2ae;
      color: #fff;
      border-radius: 5px;
      cursor: pointer;
      font-size: 16px;
      font-weight: 700;
      display: flex;
      align-items: center;
      right: 0%;
    }
  }

  .storeInfoWrap {
    margin-bottom: 20px;
    .imageWrap {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;

      .imageButton {
        margin-bottom: 10px;
      }
    }
  }

  .addButton {
    width: 100%;
    border: 1px solid #4dd2ae;
    border-radius: 5px;
    padding: 8px 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5%;
    margin-bottom: 10px;

    h5 {
      font-weight: 600;
      color: #4dd2ae;
      white-space: nowrap;
      padding: 0;
    }
  }
  .imageButton {
    background: #ffffff;
    text-align: center;
    border-radius: 5px;
    padding: 6px 14px;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    white-space: nowrap;
    cursor: pointer;
  }
  .imageButton.edit {
    border: 1px solid #cecece;
    color: #555555;
  }
  .imageButton.delete {
    border: 1px solid #4dd2ae;
    color: #4dd2ae;
  }

  .imageList {
    display: flex;
    align-items: center;
    gap: 8px;
    overflow-x: auto;
    padding-bottom: 10px;
    flex-wrap: wrap;

    .row.between {
      align-items: flex-start;
    }

    .previewImageWrap {
      width: 120px;
      height: 120px;
      position: relative;

      .imageDeleteButton {
        position: absolute;
        top: 0;
        right: 0;
        width: 24px;
        height: 24px;
        border-radius: 0 5px 0 5px;
        background: rgba(0, 0, 0, 0.3);
      }
    }
    .previewImageWrap.logo {
      height: 102px;
    }

    .previewImg {
      width: 100%;
      height: 100%;
      border-radius: 5px;
      object-fit: cover;
    }
    .previweImg.logo {
      height: 102px;
    }

    .photoBox {
      width: 120px;
      height: 120px;
      border-radius: 5px;
      padding: 10px;
      padding-top: 20px;
      border: 1px solid #cecece;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 6px;
      cursor: pointer;

      h5 {
        color: #a7a7a7;
        font-weight: 400;
      }
    }
    .photoBox.logo {
      height: 102px;
    }
  }
  .imageList.logo {
    align-items: flex-end;
  }

  input[type='file'] {
    display: none;
  }

  .warningSign {
    margin-top: 10px;
  }
  h3.subtitle {
    font-size: 18px;
    color: #2b2b2b;
    font-weight: 500;
    padding-bottom: 20px;
  }

  @media (max-width: 900px) {
    .guideBox {
      top: 30px;
      left: 20px;
    }
  }
  @media (max-width: 600px) {
    .guideBox.logo {
      top: 20px;
      left: -100px;
    }
    .guideBox.store {
      top: 20px;
      left: -200px;
    }
    .logoguideImage {
      width: 250px;
    }
    .storeguideImage {
      width: 300px;
    }
  }
`;
